import * as React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { SectionHeader } from "../../../../../../Dashboard/Components/Clients/NewBusinessWizard/Components/SharedComponents";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { InstructionPhoneNumber } from "../../../../../../../Wrap/Models/Models/Instructions/InstructionPhoneNumber";
import { CountryCodeMap } from "../../../../../../Shared/Entities/Maps/CountryCodeMap";
import { CountryCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CountryCode";
import { Email, Numeric, Phone } from "../../../../../../../react-core/Html/Validation/RegExPatterns";
import { ValidatorContents } from "../../../../../../Dashboard/Common/ValidatorHelper";
import { Validate } from "../Validation/Validate";

interface ICountryPhoneProps extends React.Props<CountryPhone> {
    isReview?: boolean;
    isFax?: boolean;
    data: InstructionPhoneNumber;
    sectionHeader: string;
    required?: boolean;
    onChange: (changes) => void;
    onRef: (ref) => void;
}

interface ICountryPhoneState {}

export const emptyInstructionPhone: InstructionPhoneNumber = {
    Country: null,
    AreaCode: null,
    Number: null,
};

export class CountryPhone extends FormComponent<ICountryPhoneProps, ICountryPhoneState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    private onChange(changes) {
        const { data } = this.props;
        let _data: InstructionPhoneNumber;
        if (!data) {
            _data = { Country: null, AreaCode: null, Number: null };
        } else {
            _data = JSON.parse(JSON.stringify(data));
        }
        for (const key in changes) {
            _data[key] = changes[key];
        }
        this.props.onChange(_data);
    }

    render() {
        const { data, sectionHeader, isReview, required, isFax } = this.props;

        return (
            <>
                {SectionHeader(
                    sectionHeader,
                    "When any field in this section is entered, all three fields(Country, Area Code, Number) need to be entered"
                )}
                <SelectEditor
                    options={CountryCodeMap.getArray()}
                    getText={(v) => {
                        return CountryCodeMap.getString(v);
                    }}
                    disabled={isReview}
                    placeholder="Please select"
                    required={required ? "Please select a Country" : null}
                    label="Country"
                    selected={data?.Country}
                    onChange={(v) => this.onChange({ Country: v })}
                />
                <TextBoxEditor
                    label="Area code"
                    required={required && (data?.Country || data?.Number) ? "Please enter area code" : null}
                    value={data?.AreaCode}
                    disabled={isReview}
                    maxLength={4}
                    regex={{ errorMessage: "Invalid area code", value: Numeric }}
                    onChange={(v) => this.onChange({ AreaCode: v })}
                    alwaysValidateOnUpdate={true}
                />
                <TextBoxEditor
                    label="Number"
                    required={required && (data?.Country || data?.AreaCode) ? "Please enter number" : null}
                    value={data?.Number}
                    disabled={isReview}
                    maxLength={20}
                    regex={{ errorMessage: ValidatorContents.InvalidPhone, value: Phone }}
                    onChange={(v) => this.onChange({ Number: v })}
                    alwaysValidateOnUpdate={true}
                />
            </>
        );
    }
}
